/*
 * @Author: liujiang liujiang@shjinjia.com.cn
 * @Date: 2025-02-20 18:15:21
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @LastEditTime: 2025-05-27 12:44:41
 * @FilePath: /oak/src/store/modules/routerMap/views/underlyingService.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 底层服务
const map = {
  docStorageManagement: () => import('@/views/underlyingService/DocStorageManagement'), // 文件存储管理
  docAccessLog: () => import('@/views/underlyingService/DocAccessLog'), // 文件访问日志
  docPermissionManagement: () => import('@/views/underlyingService/DocPermissionManagement'), // 文件权限管理
  deadLetterQueueTablelist: () => import('@/views/underlyingService/DeadLetterQueueTablelist'), // 死信队列
  configurationList: () => import('@/views/underlyingService/ConfigurationList'), // 死信队列配置列表
  lowCodeFeiShuTest: () => import('@/views/lowCodeFeiShu/test/index') // 飞书低代码

}

export default map
